import { useEffect, useState } from 'react';
/**
 * 由于移动端 100vh 并不是准确的视窗高度（可能被导航栏遮挡）
 * 故实现该 hook 获取真正的视窗高度
 * @returns 视窗高度
 */
export function useInnerHeight() {
  const [height, setHeight] = useState<string | number>('100vh');
  useEffect(() => {
    setHeight(window.innerHeight);
    const listener = () => {
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', listener);
    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);
  return { height };
}
